import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";

const useStyles = makeStyles((theme) => ({
  high: {
    zIndex: 400,
  },
  snackContent: {
    minWidth: "0px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: "1.1rem",
  },
  root: {
    position: "absolute",
    top: 0,
    bottom: "auto",
    margin: "0px auto",
    width: "fit-content",
    marginTop: 10,
    zIndex: 400,
  },
}));

export default React.memo(function MapInfo({ snackPack, setSnackPack }) {
  const [open, setOpen] = useState(false);
  const [messageInfo, setMessageInfo] = useState(undefined);

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      setOpen(false);
    }
  }, [snackPack, messageInfo, open, setSnackPack]);

  const handleClose = (e, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const classes = useStyles();
  return (
    <div className={classes.high}>
      <Snackbar
        className={classes.root}
        key={messageInfo ? messageInfo.key : undefined}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        ContentProps={{ className: classes.snackContent }}
        open={open}
        autoHideDuration={100000}
        transitionDuration={100}
        onClose={handleClose}
        TransitionProps={{ onExited: handleExited }}
        message={
          messageInfo ? (
            <>
              <span>{messageInfo.message}</span>
              {messageInfo.cases !== null && (
                <strong>{`: ${numberWithCommas(messageInfo.cases)}`}</strong>
              )}
            </>
          ) : undefined
        }
      />
    </div>
  );
});
